import VueRouter from 'vue-router';
import Results from './views/Results.vue';
import Overlay from './views/Overlay.vue';

const routes = [
  {
    name: 'search',
    path: '/:langcode?/resources/downloads/sloan-image-library',
    component: Results,
    props: true
  },
  {
    name: 'result',
    path:
      '/:langcode?/resources/downloads/sloan-image-library/:id',
    component: Overlay,
    props: true
  }
];

const scrollableElement = '.body-wrap';
let previousScrollTop = 0;

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  if (from.name === 'result') return next();
  const element = document.querySelector(scrollableElement);
  previousScrollTop = element.scrollTop;
  next();
});

router.afterEach((to, from) => {
  if (from.name === 'result') {
    const element = document.querySelector(scrollableElement);
    setTimeout(() => {
      element.scrollTop = previousScrollTop;
    }, 0);
  }
});

export default router;
